import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./styles.scss";

import Header from "components/Layout/Header";

import ButtonBar from "components/ButtonBar";
import Document from "components/Document";
import Modal01 from "components/Modal/Modal01";
import Modal02 from "components/Modal/Modal02";

import { reset } from "module/passModule";
import { sussessorComplete, contractComplete, docsAction } from "module/contractModule";
import UploadLoading from "components/Loading/uploadLoading";

const SuccessorSignStep2 = (props) => {
    const dispatch = useDispatch();
    const CI = useSelector((state) => state.pass.info);
    const personal = useSelector((state) => state.contract.isPersonal);
    const { data } = useSelector((state) => state.contract);
    const estimate = useSelector((state) => state.contract.estimate);
    const custId = useSelector((state) => state.contract.custId);
    const signature = useSelector((state) => state.user.signature);
    const mapping = useSelector((state) => state.contract.mapping);

    const complete = useSelector((state) => state.contract.complete);
    const isAll = useSelector((state) => state.user.isAll);
    const E_SUBMICD = useSelector((state) => state.contract.E_SUBMICD);
    // [eKYC TO-BE] 마지막 PASS/공동인증 제거로 불필요
    // const recordName = useSelector((state) => state.ars.recordName);
    // const derName = useSelector((state) => state.ars.derName);
    const KUNNR = useSelector((state) => state.contract.KUNNR);
    const bankAccount = useSelector((state) => state.ars.bankAccount);
    const bankCd = useSelector((state) => state.ars.bankCd);
    const custnm = useSelector((state) => state.ars.custnm);
    const bildt = useSelector((state) => state.ars.bildt);
    const isComplete = useSelector((state) => state.contract.isComplete);
    const userState = useSelector((state) => state.user);
    const arsState = useSelector((state) => state.ars);
    const keys = useSelector((state) => state.user.keys);
    const completeTrueKeys = useSelector((state) => state.user.completeTrueKeys);
    const completeKeys = useSelector((state) => state.user.completeKeys);
    const cddKeys = useSelector((state) => state.user.cddKeys);
    const owner = useSelector((state) => state.user.owner);
    const cmsKeys = useSelector((state) => state.ars.cmsKeys);
    const gKeys = useSelector((state) => state.user.gKeys);
    const token = useSelector((state) => state.pass.accessToken);
    const errMsg = useSelector((state) => state.user.errMsg);
    const ES_ETCINFO = useSelector((state) => state.contract?.ES_ETCINFO);
    const bankName = useSelector((state) => state.ars?.bankName);
    const docsList = useSelector(state => state.contract.docsList);

    // [eKYC TO-BE] 마지막 PASS/공동인증 제거로 불필요
    // const [openCert, setOpenCert] = useState(false);
    // const [keyString, setKeyString] = useState("");

    const [openCheckModal, setOpenCheckModal] = useState(false);
    // [eKYC TO-BE] 마지막 PASS/공동인증 제거로 불필요: setModalOpen·setCompleteModal 호출 지점이 사라짐
    // const [modalOpen, setModalOpen] = useState(false);
    // const [completeModal, setCompleteModal] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    const [flag, setFlag] = useState(false);
    const [temp, setTemp] = useState(false);
    const [gubun, setGubun] = useState("B");
    const ES_CTR = useSelector((state) => state.contract?.ES_CTR);

    useEffect(() => {
        window.addEventListener("beforeunload", function (e) {
            e.preventDefault();
            e.returnValue = "변경사항은 저장되지 않습니다";
        });
        if (!data) {
            props.history.push("/successor/entry/b");
        }

        const currentPath = window.location.pathname;
        if ("/successor/signStep2/b" === currentPath || "/successor/signStep2/b/" === currentPath) {
            setGubun("B");
        } else if ("/successor/signStep2/a" === currentPath || "/successor/signStep2/a/" === currentPath) {
            setGubun("A");
        } else {
            setGubun("A");
        }
    }, []);

    useEffect(() => {
        if (complete !== "" && isComplete) {
            setIsLoading(false);
            dispatch(sussessorComplete.get.request()); // reset
            props.history.push("/complete");
        }
    }, [complete]);

    useEffect(() => {
        if (flag && !temp) {
            async function setData() {
                await setTemp(true);

                let condition = [];
                await keys.map((item) => {
                    if (userState[item] && userState[item] !== "") {
                        if (item === "PLAN_ETC") {
                            condition.push({ id: personal ? "S1_PLAN_ETC_TX" : "S2_PLAN_ETC_TX", value: userState[item] });
                        } else if (item === "USE_ETC") {
                            condition.push({ id: personal ? "S1_USE_ETC" : "S2_USE_CK3_ETC", value: userState[item] });
                            // } else if (item === "S1_AGE" || item === "S1_POINT" || item === "S2_TERM") {
                        } else if (item === "S1_AGE" || item === "S2_TERM") {
                            condition.push({ id: item, value: userState[item] });
                        } else {
                            condition.push({ id: userState[item], value: true });
                        }
                    }
                });
                await completeTrueKeys.map((key) => {
                    // 필수 동의였던 키들 (무조건 _Y)
                    if ((!key.includes("CMS_AGREE") || ES_CTR?.SUBMICDA === "B") && (!key.includes("R_AGREE") || personal)) {
                        condition.push({ id: `${key}_Y`, value: true });
                    }
                });
                if (personal) {
                    await completeKeys.map((key) => {
                        if (userState[key]) {
                            condition.push({ id: `${key}_Y`, value: true });
                        } else {
                            condition.push({ id: `${key}_N`, value: true });
                        }
                    });
                } else {
                    await cddKeys.map((key) => {
                        if (userState[key] && userState[key] !== "") {
                            condition.push({ id: key, value: userState[key] });
                        }
                    });
                    await condition.push({ id: "CDD_TYPE", value: owner });
                }
                await cmsKeys.map((key) => {
                    if (arsState[key] && arsState[key] !== "") {
                        if (key === "bildt") {
                            condition.push({ id: arsState[key], value: true });
                        } else {
                            condition.push({ id: key, value: arsState[key] });
                        }
                    }
                });
                await gKeys.map((key) => {
                    if (userState[key]) {
                        condition.push({ id: key, value: "Y" });
                    }
                });
                // await condition.push({ id: "bankIdentification", value: custId });
                await condition.push({ id: `${personal ? "S1" : "S2"}_AGREE_Y`, value: true });

                dispatch(reset.get.fail());
                if (ES_CTR?.SUBMICDA === "B") {
                    dispatch(
                        sussessorComplete.post.request({
                            signData: signature,
                            signCondition: condition,
                            mapping: mapping,
                            isAll: isAll,
                            I_ETMTSEQ: estimate,
                            custId: custId,
                            isComplete: true,
                            CI: CI,
                            docsList: docsList,
                            BANKN: bankAccount,
                            bankCd: bankCd,
                            BANKL_NM: bankName,
                            isCompany: !personal,
                            custnm: custnm,
                            KUNNR: KUNNR,
                            BILDT: ES_ETCINFO.BILDT,
                            token: token,
                            I_GUBUN: gubun,
                            fAgreeY: true,
                        })
                    );
                } else {
                    dispatch(
                        sussessorComplete.post.request({
                            signData: signature,
                            signCondition: condition,
                            mapping: mapping,
                            isAll: isAll,
                            I_ETMTSEQ: estimate,
                            custId: custId,
                            isComplete: true,
                            CI: CI,
                            token: token,
                            I_GUBUN: gubun,
                            docsList: docsList,
                            fAgreeY: true,
                        })
                    );
                }
                setIsLoading(true);
            }
            setData();
        }
    }, [flag]);

    useEffect(() => {
        if (errMsg === "TIME OVER") {
            setIsLoading(false);
        }
    }, [errMsg]);

    // [eKYC TO-BE] 마지막 PASS/공동인증 제거 — 모달 확인 후 바로 flag 설정
    const handlePass = () => {
        setOpenCheckModal(false);
        setFlag(true);
    };

    /* [eKYC TO-BE] 마지막 PASS/공동인증 제거로 불필요
    const handlePass = async () => { ... NICE PASS 인증 로직 ... };
    const SendForm = (result, postData) => { ... 공동인증 콜백 로직 ... };
    const handleClickCertPopup = () => { ... 이니텍 팝업 로직 ... };
    const openCertWindow = () => { ... NICE 팝업 로직 ... };
    const getMsg = (e) => { ... NICE 콜백 수신 로직 ... };
    */

    return (
        <>
            {isLoading && <UploadLoading />}
            <Header onClick={() => props.history.push("/")} />
            <div className={styles.contentBoardWrap}>
                <div className={styles.contentBoard}>
                    <Document sign={false} type={"all"} fieldDataList={props.location.state?.fieldDataList} />
                </div>
                <ButtonBar
                    isActive
                    leftBtnTxt={"이전"}
                    leftBtnFunc={() => ("A" === gubun ? props.history.push("/successor/signStep1/a") : props.history.push("/successor/contractInfo"))}
                    rightBtnTxt={"최종 확인"}
                    rightBtnFunc={() => setOpenCheckModal(true)}
                />
            </div>
            <Modal02
                open={openCheckModal}
                header="최종 확인"
                btnOnclick1={() => setOpenCheckModal(false)}
                btnOnclick2={handlePass}
                text1={"취소"}
                text2={"계약 신청완료"}
                btnStyle2={{ color: "#DA291C" }}
            >
                본인은 계약서에 이상이 없음을 확인하고, 계약을 신청합니다.
            </Modal02>
            {/* [eKYC TO-BE] 마지막 PASS/공동인증 제거로 불필요
            <Modal01 open={modalOpen} close={() => setModalOpen(false)} header="본인인증 실패">
                본인인증에 실패하였습니다.<br />
                잠시 후 다시 시도해주세요.
            </Modal01>
            <Modal01 open={completeModal} close={() => setCompleteModal(false)} header="계약 신청 실패">
                계약 신청에 실패하였습니다.<br />
                잠시 후 다시 시도해주세요.
            </Modal01>
            */}
            {/* [eKYC TO-BE] certForm 히든 폼 제거 (마지막 PASS 인증 제거로 불필요)
            {personal && keyString !== "" && (
                <form name="certForm" id="certForm">...</form>
            )}
            */}
        </>
    );
};

export default SuccessorSignStep2;
